  const formatTime = date => {
    console.log(date)
    var d = new Date(date).valueOf()
    console.log(d)
    const year = d.getFullYear()
    var month = d.getMonth() + 1
    if(month<10){
      month = '0' + month
    }
    const day = d.getDate()
    const hour = d.getHours()
    const minute = d.getMinutes()
    const second = d.getSeconds()
    return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
  }  
  const formatTimeYYYYMMDD = date => {
    var d = new Date(date)
    const year = d.getFullYear()
    var month = d.getMonth() + 1
    if(month<10){
      month = '0' + month
    }
    const day = d.getDate()
    const hour = d.getHours()
    const minute = d.getMinutes()
    const second = d.getSeconds()
    return [year, month, day].map(formatNumber).join('');
  }
  const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
  }
  const weekday = date=>{
    var d = new Date(date)
    var day = d.getDay();
    var week= ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    return week[day]
  }

  const formatDigit = str =>{
    if (str == undefined || str == '' || str == null) {
      return 0;
    }
    str = parseFloat(str);
    //console.log('str='+str);
  
    if (str > 10000000000000) {
      str = (str / 10000000000000).toFixed(2);
      str += '万亿';
    } else if (str > 1000000000) {
      str = (str / 1000000000).toFixed(2);
      str += '亿';
    } else if (str > 10000) {
      str = (str / 10000).toFixed(2);
      str += '万';
    }else{
      str = str.toFixed(2);
      str += '元';
    }
    return str;
  }
  const mysqlFormatTime = date => {
    console.log(date)
    if (date == undefined) {
      return ''
    }
    var year = date.year + 1900,
      month = date.month + 1,
      day = date.date,
      hour = date.hours,
      minute = date.minutes,
      seconds = date.seconds;
    //如果得到的数字小于9要在前面加'0'
    month = (month > 9) ? ("" + month) : ("0" + month);
    day = (day > 9) ? ("" + day) : ("0" + day);
    hour = (hour > 9) ? ("" + hour) : ("0" + hour);
    minute = (minute > 9) ? ("" + minute) : ("0" + minute);
    seconds = (seconds > 9) ? ("" + seconds) : ("0" + seconds);
    return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + seconds;

  }
  const secTotime = s =>{
    var t = '';
    if(s > -1){
      if(s>1000){
        s=s/1000;
      }
      var hour = Math.floor(s/3600)
      var min = Math.floor(s/60) % 60
      var sec = s % 60
      if(hour < 10) {
        t = '0'+ hour + ":"
      } else { 
        t = hour + ":"
      } 
      if(min < 10){
        t += "0"
      } 
      t += min + ":"
      if(sec < 10){
        t += "0"
      } 
      t += sec.toFixed(0)
    } 
    return t
  }

  module.exports = {
    formatTime,
    formatTimeYYYYMMDD,
    weekday,
    formatDigit,
    mysqlFormatTime,
    secTotime
  }
  


// WEBPACK FOOTER //
// ./src/utils/utils.js